import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const SECTIONS = [
  {
    h: "1. Who we are",
    p: "Dompryce (\"we\", \"us\", \"our\") operates dompryce.com, a domain price comparison and AI naming platform. Contact: support@dompryce.com.",
  },
  {
    h: "2. Data we collect",
    p: "We collect: (a) the domain queries you type into our search, (b) anonymised analytics (PostHog) such as page views, clicks, country, and device type, (c) account details (email, name, profile picture) only if you sign in with Google, and (d) cookies and similar technologies — see our Cookie Policy.",
  },
  {
    h: "3. How we use it",
    p: "We use your data to: run the comparison engine, surface trending TLDs and insights, prevent abuse, improve the product, and — only if you opt in — send you price-drop alerts on saved domains.",
  },
  {
    h: "4. Sharing & affiliates",
    p: "We never sell your personal data. When you click a \"Buy here\" link, you leave Dompryce and the destination registrar's privacy policy applies. Some outbound links carry an affiliate tag that may earn us a commission at no extra cost to you.",
  },
  {
    h: "5. Your rights (GDPR / CCPA)",
    p: "You can request access, correction, export, or deletion of your data at any time by emailing support@dompryce.com. We aim to respond within 30 days.",
  },
  {
    h: "6. Retention",
    p: "Search history is retained for up to 24 months for product analytics. Account data is retained while your account is active and deleted within 90 days of an account deletion request.",
  },
  {
    h: "7. Security",
    p: "We use industry-standard TLS, encrypted backups, and access controls. No method of transmission over the internet is 100% secure, but we work hard to protect your information.",
  },
  {
    h: "8. Children",
    p: "Dompryce is not directed at children under 13 and we do not knowingly collect personal information from them.",
  },
  {
    h: "9. Changes",
    p: "We may update this policy. Material changes will be announced on our homepage or via email if you have an account.",
  },
];

export default function Privacy() {
  return (
    <Layout>
      <Seo
        title="Privacy Policy"
        description="How Dompryce collects, uses, and protects your data when you compare domain prices and use our AI naming tools."
        path="/privacy"
      />
      <article className="mx-auto max-w-3xl py-8" data-testid="privacy-page">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Legal</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-zinc-900 md:text-5xl">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Last updated: February 2026</p>

        <div className="mt-10 space-y-8 text-base leading-relaxed text-zinc-700">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl font-semibold text-zinc-900">{s.h}</h2>
              <p className="mt-2">{s.p}</p>
            </section>
          ))}
        </div>
      </article>
    </Layout>
  );
}
